import { cx } from "@emotion/css";
import MUICheckbox, { type CheckboxProps } from "@mui/material/Checkbox";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import MUIRadioGroup from "@mui/material/RadioGroup";
import type { ReactElement, ReactNode } from "react";

import Hint from "../../NewComponents/Default/Hint";

export const Checkbox = ({ className, ...props }: CheckboxProps) => {
	return <MUICheckbox {...props} className={cx(className, "checkbox")} />;
};

interface FormControlLabelProps {
	value?: string;
	label: ReactNode;
	checked?: boolean;
	onChange?: (...params: unknown[]) => void;
	Control?: ReactElement;
	hint?: string;
	className?: string;
	labelClassName?: string;
}

export const FormControlLabel = ({
	value,
	label,
	checked,
	onChange,
	Control,
	hint,
	className,
	labelClassName,
}: FormControlLabelProps) => {
	const renderHint = () => {
		if (!hint) {
			return null;
		}

		// @ts-expect-error Hint is a JS component — will be typed after migration
		return <Hint hint={hint} />;
	};

	return (
		<div className={cx(className, "w-fit-content")}>
			<MUIFormControlLabel
				className={cx(labelClassName, "control-label", {
					"item-selected": checked,
				})}
				value={value}
				label={label}
				control={Control || <Radio />}
				checked={checked}
				onChange={(...params) => onChange?.(...params)}
			/>
			{renderHint()}
		</div>
	);
};

interface RadioGroupProps {
	className?: string;
	children: ReactNode;
	onChange?: (
		event: React.ChangeEvent<HTMLInputElement>,
		value: string,
	) => void;
	value?: string;
}

export function RadioGroup({
	className,
	children,
	onChange,
	value,
}: RadioGroupProps) {
	return (
		<MUIRadioGroup
			className={cx(className, "flex flex-row gap-12")}
			onChange={onChange}
			value={value}
		>
			{children}
		</MUIRadioGroup>
	);
}
